module.exports = {"id":"155897","name":"Clint Dempsey","rating":"78","photo":"./data/images/photos/1/155897.png","club":{"name":"Seattle Sounders","logo":"./data/images/clubs/SeattleSounders.png"},"positions":["ATT","MOC","BU","MG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ClintDempsey0.json
// module id = 842
// module chunks = 0